import React from 'react'
import { Button, FormGroup, FormControl, ControlLabel, Form} from 'react-bootstrap';
import { ToastContainer, ToastMessage } from 'react-toastr';
import TextareaAutosize from '../forms/TextareaAutosize';

import JarvisWidget from '../layout/widgets/JarvisWidget.jsx'

const ToastMessageFactory = React.createFactory(ToastMessage.animation);

let FirbaseTest = React.createClass({

  getInitialState: function () {
    return {
      fcmBody: `{
  "to":"fUXBdDXEluA:APA91bGq4KbQRffs-M7ZFHYCnPpi6rp4ZOmpAZgQervcb3p9LLCbMP7ZHoii3QsbiB9rdj9TlyepbauRVNSFBj9McdtjuR4w3WQh6rSh0nCeIQYLMocqsNnojzUDtRbFkyAuctYuAVk7",
  "notification":{
      "body":"great match!",
      "title":"Push テスト"
  },
  "priority":"high"
}`,
      sendButtonTxt: 'Send',
      buttonDisabled: false
    }
  },

  handleBodyChange: function (e) {

    this.setState({ fcmBody: e.target.value});

  },
  handleOnClick: function (e) {

    var self = this;

    this.setState({ sendButtonTxt: 'Sending...' });
    this.setState({ buttonDisabled: true });

    $.ajax({
      url: this.props.fcmUrl,
      type: "POST",
      dataType: 'json',
      contentType: "application/json",
      cache: false,
      data: this.state.fcmBody
    }).done(function (msg) {

      console.log(msg);

      // self.refs.container.success(msg);

      self.refs.container.info(
        `Response: ${JSON.stringify(msg)}`,
        "正常に送信しました。", {
          timeOut: 5000,
          extendedTimeOut: 5000,
          closeButton: true
        });

      self.setState({ sendButtonTxt: 'Send' });
      self.setState({ buttonDisabled: false });

    }).fail(function (jqXHR, textStatus) {
      console.log(jqXHR);

      self.setState({ sendButtonTxt: 'Send' });
      self.setState({ buttonDisabled: false });

    });
  },
  render: function () {

    return (

      <JarvisWidget colorbutton={false} editbutton={false} custombutton={false}>
          <header>
            <span className="widget-icon">
              <i className="fa fa-edit" />
            </span>
            <h2>Firbase Test</h2>
          </header>
          {/* widget div*/}
          <div>
            {/* widget content */}
            <div className="widget-body no-padding">

                <div>

                  <ToastContainer ref="container"
                    toastMessageFactory={ToastMessageFactory}
                    className="toast-top-right" />

                    <form className="smart-form">

                      <header>FCM Test</header>

                      <fieldset>

                      <section>
                        <label className="textarea">
                          <TextareaAutosize onResize={() => {}} rows="5" value={this.state.fcmBody} onChange={this.handleBodyChange} />
                        </label>
                      </section>

                      </fieldset>

                      <footer>
                        <Button bsStyle="primary" disabled={this.state.buttonDisabled} onClick={this.handleOnClick}>{this.state.sendButtonTxt}
                        </Button>
                      </footer>
                    </form>

                </div>
            </div>
          </div>
        </JarvisWidget>

    )
  }

});

export default FirbaseTest



// WEBPACK FOOTER //
// ./src/components/notification/FirbaseTest.js